"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createResourceLoader = void 0;
var editor_elements_conventions_1 = require("@wix/editor-elements-conventions");
var RegistryError_1 = require("../errors/RegistryError");
var flags_1 = require("../flags");
var evaluateBundle_1 = require("./evaluateBundle");
var getModel_1 = require("./getModel");
var createRegistryDataTransport_1 = require("./createRegistryDataTransport");
var createEnvironmentLoader_1 = require("./createEnvironmentLoader");
var loadAssets_1 = require("./loadAssets");
var HOT_BUNDLE_ID = 'hot';
function fetchAndEvaluate(_a) {
    var fetcher = _a.fetcher, url = _a.url, id = _a.id, _b = _a.title, title = _b === void 0 ? 'Bundle' : _b, globals = _a.globals;
    return __awaiter(this, void 0, void 0, function () {
        var bundle, e_1;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _c.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, fetcher(url)];
                case 1:
                    bundle = _c.sent();
                    return [3 /*break*/, 3];
                case 2:
                    e_1 = _c.sent();
                    throw RegistryError_1.createException(title + " fetch error", RegistryError_1.RegistryErrorCode.FetchError)
                        .withOriginalErrorMessage(e_1.message)
                        .withUrl(url);
                case 3:
                    try {
                        return [2 /*return*/, evaluateBundle_1.evaluateBundle(bundle, { id: id, globals: globals })];
                    }
                    catch (e) {
                        throw RegistryError_1.createException(title + " evaluation error", RegistryError_1.RegistryErrorCode.BundleEvaluationError)
                            .withOriginalErrorMessage(e.message)
                            .withUrl(url);
                    }
                    return [2 /*return*/];
            }
        });
    });
}
function loadScript(_a) {
    var _this = this;
    var id = _a.id, url = _a.url, _b = _a.title, title = _b === void 0 ? 'Bundle' : _b;
    try {
        var script_1 = document.createElement('script');
        script_1.src = url;
        document.head.appendChild(script_1);
        return new Promise(function (resolve) {
            script_1.addEventListener('load', function () { return __awaiter(_this, void 0, void 0, function () {
                var model;
                return __generator(this, function (_a) {
                    if (id) {
                        model = getModel_1.getGlobalModel(id);
                        resolve(model);
                    }
                    else {
                        resolve(undefined);
                    }
                    return [2 /*return*/];
                });
            }); });
        });
    }
    catch (e) {
        throw RegistryError_1.createException(title + " loading error", RegistryError_1.RegistryErrorCode.BundleEvaluationError)
            .withOriginalErrorMessage(e.message)
            .withUrl(url);
    }
}
function createPromiseGuard() {
    var requests = new Map();
    return function (id, factory) {
        if (requests.has(id)) {
            return requests.get(id);
        }
        var pending = factory();
        requests.set(id, pending);
        return pending;
    };
}
function withRetry(_a) {
    var _this = this;
    var times = _a.times, task = _a.task;
    var counter = 0;
    return new Promise(function (resolve, reject) {
        var run = function () { return __awaiter(_this, void 0, void 0, function () {
            var response, e_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, task()];
                    case 1:
                        response = _a.sent();
                        resolve(response);
                        return [3 /*break*/, 3];
                    case 2:
                        e_2 = _a.sent();
                        counter++;
                        if (counter >= times) {
                            reject(e_2);
                        }
                        else {
                            run();
                        }
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        run();
    });
}
function createResourceLoader(params) {
    var api = __assign(__assign({}, createRegistryDataTransport_1.createRegistryDataTransport()), params.transport);
    var loadResource = function (_a) {
        var fetcher = _a.fetcher, url = _a.url, id = _a.id, _b = _a.title, title = _b === void 0 ? 'Bundle' : _b;
        return withRetry({
            times: 3,
            task: function () {
                if (params.useScriptsInsteadOfEval && flags_1.isBrowser) {
                    return loadScript({
                        id: id,
                        url: url,
                        title: title,
                    });
                }
                else {
                    return fetchAndEvaluate({
                        fetcher: fetcher,
                        url: url,
                        id: id,
                        title: title,
                        globals: params.globals,
                    });
                }
            },
        });
    };
    return {
        fetchLibraryManifest: function (_a) {
            var url = _a.url;
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_b) {
                    return [2 /*return*/, api.fetchLibraryManifest(url)];
                });
            });
        },
        fetchLibraryRuntime: function (_a) {
            var url = _a.url;
            return __awaiter(this, void 0, void 0, function () {
                var element;
                return __generator(this, function (_b) {
                    element = getModel_1.getScriptTag(url);
                    if (element) {
                        return [2 /*return*/, Promise.resolve()];
                    }
                    return [2 /*return*/, loadResource({
                            url: url,
                            title: 'Library Runtime Bundle',
                            fetcher: api.fetchLibraryRuntime,
                        })];
                });
            });
        },
        fetchLibraryHotBundle: function (_a) {
            var url = _a.url;
            return __awaiter(this, void 0, void 0, function () {
                var element;
                return __generator(this, function (_b) {
                    element = getModel_1.getScriptTag(url);
                    if (element) {
                        return [2 /*return*/, Promise.resolve()];
                    }
                    return [2 /*return*/, loadResource({
                            url: url,
                            id: HOT_BUNDLE_ID,
                            title: 'Library Hot Bundle',
                            fetcher: api.fetchLibraryHotBundle,
                        })];
                });
            });
        },
        createBundleLoader: function (_a) {
            var _this = this;
            var environment = _a.environment;
            var environmentLoader = environment
                ? createEnvironmentLoader_1.createEnvironmentLoader({
                    loadHotBundle: this.fetchLibraryHotBundle,
                    loadRuntime: this.fetchLibraryRuntime,
                    environment: environment,
                })
                : null;
            var guard = createPromiseGuard();
            return function (_a) {
                var url = _a.url, id = _a.id, _b = _a.assets, assets = _b === void 0 ? [] : _b;
                return __awaiter(_this, void 0, void 0, function () {
                    var loadingBundlePromise, factory;
                    var _this = this;
                    return __generator(this, function (_c) {
                        switch (_c.label) {
                            case 0:
                                /**
                                 * `loadingAssetsPromise` – not sure we should wait until CSS is laoded,
                                 * since it may cause waterfall
                                 */
                                // let loadingAssetsPromise: Promise<any> | null = null;
                                if (assets && params.shouldLoadCSSAssets) {
                                    // loadingAssetsPromise = loadAssets(assets);
                                    loadAssets_1.loadAssets(assets);
                                }
                                loadingBundlePromise = url
                                    ? guard(url, function () { return __awaiter(_this, void 0, void 0, function () {
                                        return __generator(this, function (_a) {
                                            switch (_a.label) {
                                                case 0:
                                                    if (!(environmentLoader && !environmentLoader.isLoaded())) return [3 /*break*/, 2];
                                                    return [4 /*yield*/, environmentLoader.load()];
                                                case 1:
                                                    _a.sent();
                                                    _a.label = 2;
                                                case 2: return [2 /*return*/, loadResource({
                                                        url: url,
                                                        id: id,
                                                        title: "Bundle \"" + url + "\"",
                                                        fetcher: api.fetchComponentsBundle,
                                                    })];
                                            }
                                        });
                                    }); })
                                    : null;
                                return [4 /*yield*/, loadingBundlePromise];
                            case 1:
                                _c.sent();
                                if (!(id && url)) return [3 /*break*/, 3];
                                return [4 /*yield*/, getModel_1.getGlobalModel(editor_elements_conventions_1.getLazyFactoryID(id))];
                            case 2:
                                factory = _c.sent();
                                if (factory) {
                                    factory();
                                }
                                /**
                                 * Probably we need to check pending script tags
                                 */
                                return [2 /*return*/, getModel_1.getGlobalModel(id)];
                            case 3: return [2 /*return*/, null];
                        }
                    });
                });
            };
        },
    };
}
exports.createResourceLoader = createResourceLoader;
//# sourceMappingURL=createResourceLoader.js.map